import React, { useState, useRef } from "react";
import styles from "../chatPage.scss";
import {
  SendOutlined,
  PaperClipOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import ReactGA from "react-ga4";
import { ChatFileUploader } from "./ChatFileUploader";
import { CHAT_MAX_FILES_PER_MESSAGE } from "./constants";
import { AutoResizeTextArea } from "../../../components/AutoResizeTextArea";
import { useTextFormSubmit } from "./hooks/useTextFormSubmit";
import { useAttachmentButton } from "./hooks/useAttachmentButton";
import { ContactXMLAgencyModal } from "./ContactXMLAgencyModal";
import { Chat } from "../../../typings/interfaces";
import { Button as ButtonComponent } from "../../../components/Button/Button";
import { SendAddressModals } from "./SendAddressModal/SendAddressModals";
import { useSendAddress } from "./hooks/useSendAddress";
import { Button } from "antd";

type Props = {
  adId?: string;
  chatId?: string;
  handleTextFormClick: () => void;
  isMobile: boolean;
  chat: Chat
}

export const TextForm = ({ adId, chatId, handleTextFormClick, isMobile, chat }: Props) => {
  const [message, setMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isContactXMLAgencyModalShown, setIsContactXMLAgencyModalShown] = useState(false);
  const textAreaRef = useRef(null);
  const { textFormSubmit, isUploading } = useTextFormSubmit(
    adId,
    chatId,
    message,
    setMessage,
    selectedFiles,
    setSelectedFiles,
    textAreaRef
  )
  const { onAttachmentButtonClick } = useAttachmentButton(selectedFiles, setSelectedFiles)
  const {
    handleOpenSendAddressModal,
    isSendAddressModalShown,
    handleCloseSendAddressModals
  } = useSendAddress()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (chat.canSendContactInfo) {
      setIsContactXMLAgencyModalShown(true)

      ReactGA.event({
        category: "Slanje kontakt podataka XML",
        action: "Click",
        label: "Prikazan modal"
      });

    } else {
      textFormSubmit()
    }
  }

  const handleChange = (e) => {
    setMessage(e.target.value);
  };

  const onPressEnter = (e) => {
    if (e.shiftKey || isMobile) return;
    handleSubmit(e)
  }



  const canSubmit = Boolean(message.trim()) || selectedFiles.length > 0;

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit}>
        <div className={styles.messagesTextInputWrapper}>
          {/* File preview just above text input */}
          {selectedFiles.length > 0 && (
            <ChatFileUploader
              onFilesSelected={setSelectedFiles}
              disabled={isUploading}
              selectedFiles={selectedFiles}
            />
          )}
          <div className={styles.inputContainer}>
            {/* Attachment button positioned in top right corner */}
            <div className={styles.attachmentButtonWrapper}>
              <Button
                onClick={onAttachmentButtonClick}
                disabled={isUploading || selectedFiles.length >= CHAT_MAX_FILES_PER_MESSAGE}
                className={styles.attachmentButton}
              >
                <PaperClipOutlined className={styles.icon} />
              </Button>
            </div>
            {chat.canSendUserAddress && (
              <div className={styles.sendAddressButtonWrapper}>
                <Button
                  onClick={handleOpenSendAddressModal}
                  className={styles.attachmentButton}
                >
                  <EnvironmentOutlined className={styles.icon} />
                  Pošalji adresu
                </Button>
              </div>)}

            <div className={styles.inputRow}>
              <AutoResizeTextArea
                ref={textAreaRef}
                className={`${styles.textArea} ${styles.textAreaWrapper}`}
                onPressEnter={onPressEnter}
                placeholder="Unesite Vašu poruku"
                value={message}
                onChange={handleChange}
                onClick={handleTextFormClick}
                autoFocus
                disabled={isUploading}
                autoSize={{ minRows: 1, maxRows: 10 }}
                maxLength={600}
              />
              <ButtonComponent
                type="primary"
                htmlType="submit"
                disabled={!canSubmit}
                loading={isUploading}
                className={styles.submitButton}
              >
                {isUploading ? null : <SendOutlined />}
              </ButtonComponent>
            </div>
            <div className={styles.charCounter}>
              {message.length} / 600
            </div>
          </div>
        </div>
      </form>
      <ContactXMLAgencyModal
        visible={isContactXMLAgencyModalShown}
        setIsContactXMLAgencyModalShown={setIsContactXMLAgencyModalShown}
        chat={chat}
        textFormSubmit={textFormSubmit}
      />
      <SendAddressModals
        visible={isSendAddressModalShown}
        handleCloseSendAddressModals={handleCloseSendAddressModals}
        textFormSubmit={textFormSubmit}
      />
    </React.Fragment>

  )

}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/TextForm.tsx